/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ValuedCustomerCaseQueryCsvResponse } from '../models/ValuedCustomerCaseQueryCsvResponse';
import type { ValuedCustomerCaseQueryResult } from '../models/ValuedCustomerCaseQueryResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ValuedCustomerCaseControllerService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns ValuedCustomerCaseQueryCsvResponse OK
     * @throws ApiError
     */
    public getCsv({
        isClosed,
        activeTermNumber,
        os,
        shopIds,
    }: {
        isClosed?: boolean,
        activeTermNumber?: number,
        os?: 'IOS' | 'Android' | 'Others',
        shopIds?: Array<string>,
    }): CancelablePromise<ValuedCustomerCaseQueryCsvResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/v2/valued_customer_case/csv',
            query: {
                'isClosed': isClosed,
                'activeTermNumber': activeTermNumber,
                'os': os,
                'shopIds': shopIds,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
    /**
     * @returns ValuedCustomerCaseQueryResult OK
     * @throws ApiError
     */
    public find({
        skip,
        limit,
        isClosed,
        activeTermNumber,
        os,
        shopIds,
    }: {
        skip?: number,
        limit?: number,
        isClosed?: boolean,
        activeTermNumber?: number,
        os?: 'IOS' | 'Android' | 'Others',
        shopIds?: Array<string>,
    }): CancelablePromise<ValuedCustomerCaseQueryResult> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/v2/valued_customer_case',
            query: {
                'skip': skip,
                'limit': limit,
                'isClosed': isClosed,
                'activeTermNumber': activeTermNumber,
                'os': os,
                'shopIds': shopIds,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }
}
